import { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { polesOf, withOtherSales, type SalesPole } from './poles'
import type { SaleAuthData } from './types'

const storageKey = (userId?: string | number | null) => `hop-additional-sales-pole:${userId ?? ''}`

const readStoredPole = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

const storePole = (key: string, id: string): boolean => {
  try {
    window.localStorage.setItem(key, id)
    return true
  } catch {
    return false
  }
}

const useSalesPole = (available: string[] = []) => {
  const { country, userId }: SaleAuthData = useSelector(selectAuthData) ?? {}
  const poles = withOtherSales(polesOf(country), available)
  const key = storageKey(userId)
  const [poleId, setPoleId] = useState(() => readStoredPole(key))
  const pole: SalesPole | null = poles.find(candidate => candidate.id === poleId) ?? null

  const selectPole = (id: string) => {
    setPoleId(id)
    storePole(key, id)
  }

  return { poles, pole, needsPole: poles.length > 0, selectPole }
}

export default useSalesPole
